var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "17px",
    viewBox: "0 0 15 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Twitch_Glitch_Logo_Purple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PEA-in-my-head",
    transform: "translate(-1160.000000, -2516.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(426.000000, 2416.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(659.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(29.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Twitch_Glitch_Logo_Purple",
    transform: "translate(46.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFF",
    opacity: 0,
    points: "12.9861111 7.67361111 10.625 10.0347222 8.26388889 10.0347222 6.19791667 12.1006944 6.19791667 10.0347222 3.54166667 10.0347222 3.54166667 1.18055556 12.9861111 1.18055556"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.95138889,0 L0,2.95138889 L0,13.5763889 L3.54166667,13.5763889 L3.54166667,16.5277778 L6.49305556,13.5763889 L8.85416667,13.5763889 L14.1666667,8.26388889 L14.1666667,0 L2.95138889,0 Z M12.9861111,7.67361111 L10.625,10.0347222 L8.26388889,10.0347222 L6.19791667,12.1006944 L6.19791667,10.0347222 L3.54166667,10.0347222 L3.54166667,1.18055556 L12.9861111,1.18055556 L12.9861111,7.67361111 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.0347222,
    y: 3.24652778,
    width: 1.18055556,
    height: 3.54166667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.78819444,
    y: 3.24652778,
    width: 1.18055556,
    height: 3.54166667
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.f64bd9d0e94c2a021be449e119ce97a9.svg";
export { ForwardRef as ReactComponent };